import angular from 'angular';
import moment from 'moment';

import { RegistrationGroup } from './model/registrationGroup';
import { Registration } from './model/registration';
import { castJSON } from '../helpers';
import { emptyGuid, guid1, isGuid } from '@/shared/utils/guid';
import AuthService from '@/shared/services/AuthService';

import SignalRService from '@/shared/services/SignalRService';
import userStorage from '@/shared/services/userStorage';
import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';

const columnSelectionStorageKey = 'RegistrationOverviewHiddenColumns';
const knownStateParams = [
  'relation',
  'period',
  'finalInvoiceStreamId',
  'userId',
  'dateFrom',
  'dateUntil',
  'invoiceDateFrom',
  'invoiceDateUntil',
  'resourceId',
  'invoiceId',
  'intraCompanyInvoiceId',
  'filters',
];

angular
  .module('cxRegistrations')
  .controller('RegOverviewCtrl', [
    '$q',
    'resourceFactorySvc',
    'flySvc',
    'registrationService',
    'dataCache',
    '$filter',
    '$stateParams',
    '$locale',
    'regDialogsSvc',
    'checkSecurity',
    'checkFeature',
    'dialogsSvc',
    '$state',
    'resourceNameFilter',
    'invoiceDialogsSvc',
    '$http',
    'appUrls',
    '$timeout',
    '$scope',
    '$translate',
    regOverviewCtrl,
  ]);

function regOverviewCtrl(
  $q,
  resourceFactorySvc,
  flySvc,
  registrationService,
  dataCache,
  $filter,
  $stateParams,
  $locale,
  regDialogsSvc,
  checkSecurity,
  checkFeature,
  dialogsSvc,
  $state,
  resourceNameFilter,
  invoiceDialogsSvc,
  $http,
  appUrls,
  $timeout,
  $scope,
  $translate,
) {
  var registrationResource = resourceFactorySvc.get('registration');
  var vm = this;
  vm.registrationService = registrationService;
  vm.relation = null;
  vm.resources = [];
  vm.locale = $locale;
  vm.currentUser = dataCache.getArray('employee');
  vm.period = null;
  vm.year = moment.utc().year();
  vm.filtersInitialised = false;
  vm.hasFilter = false;
  vm.manipulatingDrafts = false;
  var invoiceRegistrationResource = resourceFactorySvc.get('invoiceRegistration');
  var canViewOthers = checkSecurity('RegistrationOthers');
  var canEditOthers = checkSecurity('RegistrationOthers:u');
  vm.showAssignments = dataCache.getArray('assignmentsEnabled');

  vm.employees = canViewOthers ? dataCache.getArray('user') : [vm.currentUser];
  vm.userId = canViewOthers ? null : vm.currentUser.userID;
  vm.systemUserId = guid1;
  vm.ownCompanies = [];
  vm.taskTemplates = [];
  vm.finalInvoiceStreamId = null;
  vm.retrieveRequest = null;
  vm.kpiRequest = null;
  vm.crmTypes = [];
  vm.withLabels = [];
  vm.withoutLabels = [];
  vm.withEmployeeLabels = [];
  vm.withoutEmployeeLabels = [];
  vm.relationGroups = [];
  vm.showAdvanceFilters = false;
  vm.selectAll = false;
  vm.globalActionRunning = false;
  vm.invoiceDateFrom = null;
  vm.invoiceDateUntil = null;
  vm.assignmentTemplateId = null;
  vm.endFiscalYears = [];
  vm.referenceYear = null;
  vm.invoiceId = null;
  vm.intraCompanyInvoiceId = null;
  vm.relationHandlingLevels = [];
  if (checkSecurity('RegistrationOthers:r'))
    vm.retrieveEmployeeTags = $http.get(appUrls.api + '/api/employee/tags');
  vm.hasTrainingFeature = checkFeature('Training');
  vm.resourceTypeItems = [0, 1, 2, 3, 4, 5];
  if (!vm.hasTrainingFeature) {
    vm.resourceTypeItems = vm.resourceTypeItems.filter(id => id !== 5);
  }
  vm.getFilters = function() {
    var userId = vm.userId || '00000000-0000-0000-0000-000000000000';
    var relationId = vm.relation && !vm.finalInvoiceStreamId ? vm.relation.id : null;
    var resourceId = vm.resource ? vm.resource.id : null;
    var ownCompanies = vm.ownCompanies || [];
    const filters = {
      relationId,
      resourceId,
      ownCompanies,
      taskTemplates: vm.taskTemplates || [],
      finalInvoiceStreamId: vm.finalInvoiceStreamId,
      crmTypes: vm.crmTypes || [],
      withLabels: vm.withLabels,
      withoutLabels: vm.withoutLabels,
      withEmployeeLabels: vm.withEmployeeLabels,
      withoutEmployeeLabels: vm.withoutEmployeeLabels,
      invoiceDateFrom: vm.invoiceDateFrom
        ? moment.utc(vm.invoiceDateFrom).format('YYYY-MM-DD')
        : null,
      invoiceDateUntil: vm.invoiceDateUntil
        ? moment.utc(vm.invoiceDateUntil).format('YYYY-MM-DD')
        : null,
      userId,
      from: vm.from ? moment.utc(vm.from).format('YYYY-MM-DD') : null,
      to: vm.to ? moment.utc(vm.to).format('YYYY-MM-DD') : null,
      assignmentTemplateId: vm.assignmentTemplateId,
      endFiscalYears: vm.endFiscalYears,
      referenceYear: vm.referenceYear,
      invoiceId: vm.invoiceId,
      intraCompanyInvoiceId: vm.intraCompanyInvoiceId,
      relationGroups: vm.relationGroups,
      relationHandlingLevels: vm.relationHandlingLevels,
    };
    return filters;
  };

  const retrieveResources = () => {
    return resourceFactorySvc
      .get('resource')
      .reg({})
      .$promise.then(function(data) {
        vm.resources = data.map(item => ({
          ...item,
          label: resourceNameFilter(item),
          code: item.code || '',
        }));

        return null;
      });
  };
  retrieveResources();

  vm.retrieve = function(params) {
    if (!vm.filtersInitialised) return;
    if (params == null) params = {};

    if (vm.to >= vm.from || vm.to === null || vm.from === null) {
      var userId = vm.userId || '00000000-0000-0000-0000-000000000000';
      const filters = vm.getFilters();

      sessionStorage.setItem(
        'RegistrationOverviewParams',
        JSON.stringify({
          tableParams: params,
          ...filters,
          relation: vm.relation,
          resource: vm.resource,
          period: vm.period,
          showAdvanceFilters: vm.showAdvanceFilters,
        }),
      );

      //Cancel previous request, cancelling a completed request will have no effect
      if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
        vm.retrieveRequest.$cancelRequest();

      vm.retrieveRequest = registrationService.retrieveRegistrations(
        { ...params, ...filters },
        moment.utc(vm.from).format('YYYY-MM-DD'),
        moment.utc(vm.to).format('YYYY-MM-DD'),
        userId,
      );
      return vm.retrieveRequest.then(function({ data }) {
        let registrations = data.registrations.map(x => {
          var reg = castJSON(x, Registration);
          reg.user = vm.getUserName(reg.userId);
          reg.translate($filter);
          reg.selected = vm.selectAll;
          return reg;
        });

        if (params.page === 0) {
          refreshTotals();
        }

        vm.currentParams = params;
        vm.hasFilter = vm.hasFilters();

        return registrations;
      }, showError);
    }
  };

  const refreshTotals = () => {
    const sessionParams = JSON.parse(sessionStorage.getItem('RegistrationOverviewParams'));
    if (!sessionParams) return;

    const tableParams = sessionParams.tableParams;
    if (!tableParams) return;
    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.kpiRequest && vm.kpiRequest.$cancelRequest) vm.kpiRequest.$cancelRequest();

    var userId = vm.userId || '00000000-0000-0000-0000-000000000000';
    const filters = vm.getFilters();
    vm.kpiRequest = registrationService.retrieveKpis(
      { ...tableParams, ...filters },
      moment.utc(vm.from).format('YYYY-MM-DD'),
      moment.utc(vm.to).format('YYYY-MM-DD'),
      userId,
    );
    return vm.kpiRequest.$promise.then(function(data) {
      vm.totalMinutesFormatted = data.totalMinutes.minuteToTime();
      vm.totalAmount = data.totalAmount;
      vm.billableAmount = data.billableAmount;
      vm.billablePerHour = data.billablePerHour;
      vm.openRegCount = data.openRegCount;
      vm.totalRowCount = data.totalRowCount;
      vm.originalAmount = data.originalAmount;
    });
  };

  const initStateParams = () => {
    if (!$stateParams) return;
    const params = $stateParams;

    let hasStateParams = knownStateParams.some(x => !!params[x]);

    if (params.relation && params.relation.id) {
      vm.relation = params.relation;
      hasStateParams = true;
    }

    if (params.period) vm.setPeriod(params.period, true);
    if (params.finalInvoiceStreamId) vm.finalInvoiceStreamId = params.finalInvoiceStreamId;
    if (params.userId) vm.userId = params.userId === emptyGuid ? null : params.userId;
    if (params.dateFrom) vm.from = moment.utc(params.dateFrom).toDate();
    if (params.dateUntil) vm.to = moment.utc(params.dateUntil).toDate();
    if (params.invoiceDateFrom) vm.invoiceDateFrom = moment.utc(params.invoiceDateFrom).toDate();
    if (params.invoiceDateUntil) vm.invoiceDateUntil = moment.utc(params.invoiceDateUntil).toDate();
    if (params.resourceId)
      vm.resource = (vm.resources || []).find(x => x.id === params.resourceId) || {
        id: params.resourceId,
      };

    if (params.invoiceId) vm.invoiceId = params.invoiceId;
    if (params.intraCompanyInvoiceId) vm.intraCompanyInvoiceId = params.intraCompanyInvoiceId;
    if (params.filters) return { filter: params.filters };

    if (hasStateParams) return {};
  };
  const setParamsFromSessionStorage = () => {
    try {
      var tableParams = null;
      var stateParams = initStateParams();
      const sessionParams = JSON.parse(sessionStorage.getItem('RegistrationOverviewParams'));
      if (sessionParams) {
        vm.showAdvanceFilters = sessionParams.showAdvanceFilters || false;
        if (!stateParams) {
          //Don't override stateparams
          vm.from = sessionParams.from ? moment.utc(sessionParams.from).toDate() : null;
          vm.to = sessionParams.to ? moment.utc(sessionParams.to).toDate() : null;
          vm.userId =
            sessionParams.userId === '00000000-0000-0000-0000-000000000000'
              ? null
              : sessionParams.userId;
          // Don't override relation when it has been set by state params (navigating from relation-file to here)
          vm.relation = vm.relation || sessionParams.relation;
          vm.resource = sessionParams.resource;
          vm.ownCompanies = sessionParams.ownCompanies || [];
          vm.crmTypes = sessionParams.crmTypes || [];
          vm.taskTemplates = sessionParams.taskTemplates || [];
          vm.finalInvoiceStreamId = sessionParams.finalInvoiceStreamId;
          vm.withLabels = sessionParams.withLabels || [];
          vm.withoutLabels = sessionParams.withoutLabels || [];
          vm.withEmployeeLabels = sessionParams.withEmployeeLabels || [];
          vm.withoutEmployeeLabels = sessionParams.withoutEmployeeLabels || [];
          vm.relationGroups = sessionParams.relationGroups || [];
          vm.period = sessionParams.period;
          vm.invoiceDateFrom = sessionParams.invoiceDateFrom
            ? moment.utc(sessionParams.invoiceDateFrom).toDate()
            : null;
          vm.invoiceDateUntil = sessionParams.invoiceDateUntil
            ? moment.utc(sessionParams.invoiceDateUntil).toDate()
            : null;
          vm.assignmentTemplateId = sessionParams.assignmentTemplateId;
          vm.endFiscalYears = sessionParams.endFiscalYears;
          vm.referenceYear = sessionParams.referenceYear;
          vm.invoiceId = sessionParams.invoiceId;
          vm.intraCompanyInvoiceId = sessionParams.intraCompanyInvoiceId;
          vm.relationHandlingLevels = sessionParams.relationHandlingLevels || [];
          tableParams = sessionParams.tableParams;
        }
      }
      if (stateParams) tableParams = { ...stateParams };

      if (!vm.period) vm.setPeriod('month', true);

      if (tableParams) {
        if (vm.table) {
          vm.table.initializeParams(tableParams);
          vm.hasFilter = vm.hasFilters();
          vm.filtersInitialised = true;
        } else {
          vm.initialTableParams = tableParams;
          vm.hasFilter = vm.hasFilters() || !angular.equals(tableParams.filters, {});
          vm.filtersInitialised = true;
        }
      } else {
        vm.hasFilter = vm.hasFilters();
        vm.filtersInitialised = true;
      }
    } catch (error) {
      console.error('Error while setting parameters from session storage');
      console.error(error);
    }
  };

  vm.reloadRegistrations = () => {
    if (vm.table) {
      vm.table.reload();
    }
  };

  var showError = function(error) {
    if (error === null) return;
    if (error.status === -1) return; //Request cancelled
    flySvc.error(error);
  };

  vm.getUserName = function(userId) {
    if (!vm.employees || !userId) return;
    if (userId === guid1) return $translate.instant('SystemUser');
    const employee = vm.employees.find(e => e.userID === userId);
    if (!employee) return;
    return employee.firstName + ' ' + employee.lastName;
  };

  vm.dateFiltersChanged = function() {
    vm.period = '';
    vm.reloadRegistrations();
  };

  vm.setPeriod = function(period, noReload = false) {
    vm.period = period || 'month';

    const today = moment.utc().startOf('day');
    const currentMonth = today.month() + 1;

    switch (vm.period) {
      case 'today':
        vm.from = today.toDate();
        vm.to = today.toDate();
        break;
      case 'yesterday':
        vm.from = today
          .clone()
          .add(-1, 'days')
          .toDate();
        vm.to = today
          .clone()
          .add(-1, 'days')
          .toDate();
        break;
      case 'week':
        vm.from = today
          .clone()
          .startOf('isoWeek')
          .toDate();
        vm.to = moment
          .utc(vm.from)
          .clone()
          .add(6, 'days')
          .toDate();
        break;
      case 'month':
        vm.from = today
          .clone()
          .date(1)
          .toDate();
        vm.to = moment
          .utc()
          .endOf('month')
          .toDate();
        break;
      case 'quarter':
        vm.from = moment
          .utc()
          .startOf('quarter')
          .toDate();
        vm.to = moment
          .utc()
          .endOf('quarter')
          .toDate();
        break;
      case 'year':
        vm.from = moment
          .utc()
          .startOf('year')
          .toDate();
        vm.to = moment
          .utc()
          .endOf('year')
          .toDate();
        break;
      case 'prevWeek':
        vm.from = today
          .clone()
          .startOf('isoWeek')
          .week(today.week() - 1)
          .toDate();
        vm.to = moment
          .utc(vm.from)
          .clone()
          .add(6, 'days')
          .toDate();
        break;
      case 'prevMonth':
        vm.from = today
          .clone()
          .date(1)
          .add(-1, 'months')
          .toDate();
        vm.to = moment
          .utc(vm.from)
          .clone()
          .endOf('month')
          .toDate();
        break;
      case 'prevQuarter':
        vm.from = moment
          .utc()
          .add(-3, 'months')
          .startOf('quarter')
          .toDate();
        vm.to = moment
          .utc()
          .add(-3, 'months')
          .endOf('quarter')
          .toDate();
        break;
      case 'prevYear':
        vm.from = moment
          .utc()
          .add(-1, 'year')
          .startOf('year')
          .toDate();
        vm.to = moment
          .utc()
          .add(-1, 'year')
          .endOf('year')
          .toDate();
        break;
      case 'all':
      default:
        vm.from = null;
        vm.to = null;
        break;
    }
    if (vm.table && !noReload) {
      vm.table.reload();
    }
  };

  vm.editRegistration = function(registration) {
    if (registration.type === 3 || registration.type === 4) return vm.editAbsence(registration);
    if (registration.type === 5) return vm.editTraining(registration);
    var group = registration.group;
    var reg = new RegistrationGroup();
    var date;
    for (var j = 0; j < vm.table.rows.length; j++) {
      if (vm.table.rows[j].group && vm.table.rows[j].group === group) {
        reg.setPart(vm.table.rows[j]);
        date = vm.table.rows[j].date;
      }
    }
    reg.initDate(
      date ||
        moment
          .utc()
          .startOf('day')
          .toDate(),
    );
    reg.setRelation();

    regDialogsSvc.editRegistrationGroup(reg).then(function(result) {
      if (result) {
        flySvc.success('Registration modified');
        //Result should already be a RegistrationGroup
        var registrations = result.getRegistrationsWithId();
        registrations.forEach(function(reg) {
          reg.user = vm.getUserName(reg.userId);
          var idx = vm.table.rows.findIndex(x => x.id === reg.id);
          if (idx >= 0) {
            vm.table.rows[idx] = reg;
          } else if (
            moment.utc(reg.date).isBetween(moment.utc(vm.from), moment.utc(vm.to), 'day', '[]')
          ) {
            vm.table.rows.unshift(reg);
          }
        });

        refreshTotals();
      }
    });
  };

  vm.createRegistration = function(userId) {
    var reg = new RegistrationGroup();
    reg.date = moment
      .utc()
      .startOf('day')
      .toDate();
    if (!!vm.relation && vm.relation.crm !== 0) {
      reg.relation = vm.relation;
      reg.invoiceStreamId = getFirstSelectedInvoiceStreamId(vm.relation);
      reg.setRelation();
    }

    registrationService
      .getNextRegistrationTime(
        moment
          .utc()
          .startOf('day')
          .toDate(),
      )
      .then(function(data) {
        if (data) reg.work.initTime(data.Hour, data.Minute, 0);
        userId = userId || vm.currentUser.userID;

        reg.setUser(userId, vm.getUserName(userId));

        var vat = dataCache.getDefaultCompany().resourceVATRate || 0.21;
        reg.work.setVatRate(vat, 0);
        reg.cost.setVatRate(vat, 0);
        reg.travel.setVatRate(vat, 0);
        regDialogsSvc.editRegistrationGroup(reg).then(function(result) {
          if (result) {
            flySvc.success('Registration created');
            //Result should already be a RegistrationGroup
            var registrations = result.getRegistrationsWithId();
            registrations.forEach(function(reg) {
              reg.user = vm.getUserName(reg.userId);
              if (
                moment.utc(reg.date).isBetween(moment.utc(vm.from), moment.utc(vm.to), 'day', '[]')
              ) {
                vm.table.rows.unshift(reg);
              }
            });
            refreshTotals();
          }
        });
      });
  };

  vm.deleteRegistration = function(registration) {
    dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteRegistration').then(function() {
      registration.removing = true;
      registrationResource.delete(
        {
          id: registration.id,
          deleteGroup: false,
        },
        function() {
          registration.removing = false;
          var index = vm.table.rows.indexOf(registration);
          if (index >= 0) {
            vm.table.rows.splice(index, 1);

            refreshTotals();
          }
        },
        function(error) {
          registration.removing = false;
          showError(error);
        },
      );
    });
  };

  vm.removeRegistrationFromDraft = function(registration) {
    invoiceDialogsSvc
      .deleteWithNeverInvoice('comfirmUndoOrNeverInvoiceDetailLine')
      .then(function(neverInvoice) {
        registration.removingFromDraft = true;
        invoiceRegistrationResource.delete(
          {
            invoiceId: registration.invoiceId,
            id: registration.id,
            neverInvoice,
          },
          null,
          function(result) {
            registration.removingFromDraft = false;
            if (
              result &&
              result.updatedRegistration &&
              result.updatedRegistration.id == registration.id
            ) {
              flySvc.success('msgRemovedRegistrationFromDraftInvoice');
              registration.set(result.updatedRegistration);
              registration.translate($filter);
            }
          },
          function(error) {
            showError(error);
            registration.removingFromDraft = false;
          },
        );
      });
  };

  vm.addRegistrationToDraft = registration => {
    if (vm.manipulatingDrafts) return;
    registration.addingToDraft = true;
    vm.manipulatingDrafts = true;
    invoiceRegistrationResource.billRegistrations(null, [registration.id]).$promise.then(
      function(data) {
        registration.addingToDraft = false;
        vm.manipulatingDrafts = false;
        if (data && data.length > 0) {
          const billedRegistration = data.find(x => x.id == registration.id);
          if (billedRegistration && billedRegistration.invoiceStatus === 1) {
            registration.set(billedRegistration);
            registration.translate($filter);
            flySvc.success('msgAddedRegistrationToDraftInvoice');
          }
          if (billedRegistration && billedRegistration.invoiceStatus === 0) {
            flySvc.proposal('msgInvoiceRegistrationNoInvoiceCreated');
          }
        }
      },
      function(error) {
        registration.addingToDraft = false;
        vm.manipulatingDrafts = false;
        flySvc.error(error);
      },
    );
  };
  vm.toggleNeverInvoice = (registration, checked) => {
    if (registration.invoiceStatus > 0) return ''; //Only allowed on registrations not linked to invoice
    return registrationResource
      .toggleNeverInvoice({ id: registration.id, neverInvoice: checked }, null)
      .$promise.then(
        data => {
          registration.invoiceStatus = data.invoiceStatus;
          registration.neverInvoice = data.neverInvoice;
          return false;
        },
        error => {
          flySvc.error(error);
          return '';
        },
      );
  };
  vm.toggleBillable = (registration, checked) => {
    if (registration.invoiceStatus > 0) return ''; //Only allowed on registrations not linked to invoice
    return registrationResource
      .toggleBillable({ id: registration.id, billable: checked }, null)
      .$promise.then(
        data => {
          registration.invoiceStatus = data.invoiceStatus;
          registration.isBillable = data.isBillable;
          return false;
        },
        error => {
          flySvc.error(error);
          return '';
        },
      );
  };
  vm.toggleInForfait = (registration, checked) => {
    if (registration.invoiceStatus > 0) return ''; //Only allowed on registrations not linked to invoice
    return registrationResource
      .toggleInForfait({ id: registration.id, inForfait: checked }, null)
      .$promise.then(
        data => {
          registration.invoiceStatus = data.invoiceStatus;
          registration.inForfait = data.inForfait;
          return false;
        },
        error => {
          flySvc.error(error);
          return '';
        },
      );
  };
  vm.createReport = () => {
    if (vm.to >= vm.from) {
      var userId = vm.userId || '00000000-0000-0000-0000-000000000000';
      var relationId = vm.relation ? vm.relation.id : null;
      var resourceId = vm.resource ? vm.resource.id : null;
      vm.creatingReport = true;
      const filters = vm.getFilters();

      return registrationService
        .createReport({ ...vm.currentParams, ...filters }, vm.from, vm.to, userId)
        .$promise.then(
          function() {
            vm.creatingReport = false;
            flySvc.success('ExportToExcelStarted');
          },
          function(error) {
            vm.creatingReport = false;
            showError(error);
          },
        );
    }
  };
  vm.createDetailReport = asPdf => {
    if (!vm.relation || !vm.relation.id) {
      flySvc.warning('PleaseFilterOnRelation');
      $('#RelationField').focus();
      return;
    }
    vm.creatingReport = true;

    var batchParams = vm.getBatchSelectionParams();
    const filters = vm.getFilters();
    return regDialogsSvc
      .createInvoiceDetailReport(vm.relation, filters, batchParams)
      .finally(() => {
        vm.creatingReport = false;
      });
  };

  vm.createAbsence = function(type = 3, userId) {
    var absence = new Registration({ type });
    absence.date = moment
      .utc()
      .startOf('day')
      .toDate();
    registrationService
      .getNextRegistrationTime(
        moment
          .utc()
          .startOf('day')
          .toDate(),
      )
      .then(function(data) {
        if (data) absence.initTime(data.Hour, data.Minute, 0);
        absence.userId = userId || vm.currentUser.userID;
        absence.user = vm.getUserName(absence.userId);

        regDialogsSvc.newAbsence(absence, {}).then(function(result) {
          if (result) {
            var reg = result instanceof Registration ? result : new Registration(result);
            if (
              moment.utc(reg.date).isBetween(moment.utc(vm.from), moment.utc(vm.to), 'day', '[]')
            ) {
              reg.user = vm.getUserName(reg.userId);
              reg.translate($filter);
              vm.table.rows.push(reg);
            }

            refreshTotals();
          }
        });
      });
  };

  vm.editAbsence = function(absence) {
    var copy = angular.copy(absence);
    regDialogsSvc.editAbsence(copy, {}).then(function(result) {
      if (result) {
        absence.set(result);
        absence.translate($filter);
      }
    });
  };

  vm.createTraining = function(userId) {
    var training = new Registration({ type: 5 });
    training.date = moment
      .utc()
      .startOf('day')
      .toDate();
    registrationService
      .getNextRegistrationTime(
        moment
          .utc()
          .startOf('day')
          .toDate(),
      )
      .then(function(data) {
        if (data) training.initTime(data.Hour, data.Minute, 0);
        training.userId = userId || vm.currentUser.userID;
        training.user = vm.getUserName(training.userId);

        regDialogsSvc.newTraining(training, {}).then(function(result) {
          if (result) {
            var reg = result instanceof Registration ? result : new Registration(result);
            if (
              moment.utc(reg.date).isBetween(moment.utc(vm.from), moment.utc(vm.to), 'day', '[]')
            ) {
              reg.user = vm.getUserName(reg.userId);
              reg.translate($filter);
              vm.table.rows.push(reg);
            }

            refreshTotals();
          }
        });
      });
  };

  vm.editTraining = function(training) {
    var copy = angular.copy(training);
    regDialogsSvc.editTraining(copy, {}).then(function(result) {
      if (result) {
        training.set(result);
        training.translate($filter);
      }
    });
  };

  vm.hasFilters = function() {
    if (vm.table && vm.table.tableInfo && !angular.equals(vm.table.tableInfo.filters, {}))
      return true;

    if (canViewOthers && vm.userId && vm.userId !== '00000000-0000-0000-0000-000000000000')
      return true;
    if (vm.relation && vm.relation.id) return true;
    if (vm.resource && vm.resource.id) return true;
    if (vm.ownCompanies && vm.ownCompanies.length) return true;
    if (vm.crmTypes && vm.crmTypes.length) return true;
    if (vm.taskTemplates && vm.taskTemplates.length) return true;
    if (vm.withLabels && vm.withLabels.length) return true;
    if (vm.withoutLabels && vm.withoutLabels.length) return true;
    if (vm.withEmployeeLabels && vm.withEmployeeLabels.length) return true;
    if (vm.withoutEmployeeLabels && vm.withoutEmployeeLabels.length) return true;
    if (vm.finalInvoiceStreamId) return true;
    if (vm.invoiceDateFrom) return true;
    if (vm.invoiceDateUntil) return true;
    if (vm.assignmentTemplateId) return true;
    if (vm.endFiscalYears && vm.endFiscalYears.length) return true;
    if (vm.period !== 'month') return true;
    if (vm.referenceYear !== null) return true;
    if (vm.invoiceId !== null) return true;
    if (vm.intraCompanyInvoiceId !== null) return true;
    if (vm.relationGroups && vm.relationGroups.length) return true;
    if (vm.relationHandlingLevels && vm.relationHandlingLevels.length) return true;
    return false;
  };
  vm.clearFilters = function() {
    vm.relation = null;
    vm.resource = null;
    vm.userId = canViewOthers ? null : vm.currentUser.userID;
    vm.ownCompanies = [];
    vm.taskTemplates = [];
    vm.finalInvoiceStreamId = null;
    vm.crmTypes = [];
    vm.withLabels = [];
    vm.withoutLabels = [];
    vm.withEmployeeLabels = [];
    vm.withoutEmployeeLabels = [];
    vm.invoiceDateFrom = null;
    vm.invoiceDateUntil = null;
    vm.assignmentTemplateId = null;
    vm.endFiscalYears = [];
    vm.referenceYear = null;
    vm.invoiceId = null;
    vm.intraCompanyInvoiceId = null;
    vm.relationGroups = [];
    vm.relationHandlingLevels = [];
    vm.setPeriod('month', true);
    if (vm.table) {
      vm.table.clearFilter();
      vm.table.reload();
    }
  };
  vm.relationChanged = function(oldRelationId) {
    if (oldRelationId !== vm.relation?.id) {
      vm.finalInvoiceStreamId = null;
      vm.reloadRegistrations();
    }
  };

  vm.toggleCrmType = crmType => {
    document.activeElement.blur();
    const idx = vm.crmTypes.indexOf(crmType);
    if (idx >= 0) {
      vm.crmTypes.splice(idx, 1);
    } else {
      vm.crmTypes.push(crmType);
    }
    vm.reloadRegistrations();
  };

  vm.toggleAdvanceFilters = function() {
    vm.showAdvanceFilters = !vm.showAdvanceFilters;
    const params = JSON.parse(sessionStorage.getItem('RegistrationOverviewParams')) || {};

    sessionStorage.setItem(
      'RegistrationOverviewParams',
      JSON.stringify({
        ...params,
        showAdvanceFilters: vm.showAdvanceFilters,
      }),
    );
  };
  //Column selection
  //List of columns that can be hidden
  vm.hideableColumns = [
    { key: 'date', label: $filter('translate')('Date'), selected: true },
    {
      key: 'referenceYear',
      label: $filter('translate')('ReferenceYear'),
      selected: true,
      hiddenBySecurity: !AuthService.hasFeature('ReferenceYear'),
    },
    { key: 'user', label: $filter('translate')('User'), selected: true },
    { key: 'relation', label: $filter('translate')('Relation'), selected: true },
    { key: 'customerCode', label: $filter('translate')('CustomerCode'), selected: true },
    {
      key: 'assignment',
      label: $filter('translate')('Assignment'),
      selected: true,
      hiddenBySecurity: !dataCache.getArray('assignmentsEnabled'),
    },
    { key: 'resourceType', label: $filter('translate')('Type'), selected: true },
    { key: 'resource', label: $filter('translate')('Resource'), selected: true },
    { key: 'taskName', label: $filter('translate')('Task'), selected: true },
    {
      key: 'trainingName',
      label: $filter('translate')('Training'),
      selected: true,
      hiddenBySecurity: !AuthService.hasFeature('Training'),
    },

    { key: 'fromMinutes', label: $filter('translate')('From'), selected: true },
    { key: 'toMinutes', label: $filter('translate')('To'), selected: true },
    { key: 'quantity', label: $filter('translate')('Quantity'), selected: true },
    {
      key: 'unitPrice',
      label: $filter('translate')('Unit price'),
      selected: true,
      hiddenBySecurity: !checkSecurity('Pricelist:r'),
    },
    {
      key: 'vatPercentage',
      label: $filter('translate')('% VAT'),
      selected: true,
      hiddenBySecurity: !checkSecurity('Pricelist:r'),
    },
    {
      key: 'totalAmount',
      label: $filter('translate')('Amount'),
      selected: true,
      hiddenBySecurity: !checkSecurity('Pricelist:r'),
    },
    {
      key: 'isFixedPrice',
      label: $filter('translate')('IsFixedPrice'),
      selected: false,
      hiddenBySecurity: !checkSecurity('Pricelist:r'),
    },
    {
      key: 'isBillable',
      label: $filter('translate')('Billable'),
      selected: true,
      hiddenBySecurity: !checkSecurity('Pricelist:r'),
    },
    {
      key: 'forfaitStatus',
      label: $filter('translate')('In forfait'),
      selected: true,
      hiddenBySecurity: !checkSecurity('Pricelist:r'),
    },
    {
      key: 'invoiceForfaitStatus',
      label: $filter('translate')('Invoice in forfait'),
      selected: false,
      hiddenBySecurity: !checkSecurity('InvoiceDraft:r'),
    },
    {
      key: 'neverInvoice',
      label: $filter('translate')('Never invoice'),
      selected: true,
      hiddenBySecurity: !checkSecurity('InvoiceDraft:u'),
    },
    {
      key: 'invoiceStatus',
      label: $filter('translate')('Invoice'),
      selected: true,
      hiddenBySecurity: !checkSecurity('InvoiceDraft:r'),
    },
    { key: 'remark', label: $filter('translate')('Remark'), selected: true },
  ];
  //Store hidden columns in object for easy use
  vm.hiddenColumns = {};

  vm.rebuildHiddenColumns = function() {
    vm.hiddenColumns = vm.hideableColumns.reduce((r, i) => {
      r[i.key] = !i.selected;
      return r;
    }, {});
  };
  vm.initHiddenColumns = function() {
    const hiddenColumns = userStorage.getItem(columnSelectionStorageKey) || [];

    if (hiddenColumns.length) {
      vm.hideableColumns.forEach(col => {
        const selected =
          hiddenColumns.indexOf(col.key) < 0 ||
          // show columns that might have been hidden by user, but were selected by a state parameter when clicking to reg overview from another screen (like budget overview)
          ($stateParams.filters && $stateParams.filters[col.key]);
        col.selected = selected === true;
      });
    }
    vm.rebuildHiddenColumns();
  };

  vm.openColumnConfigDialog = function() {
    dialogsSvc
      .showCheckboxList(
        'msgSelectTableColumns',
        vm.hideableColumns
          .filter(x => !x.hiddenBySecurity)
          .map(({ key, label, selected }) => ({ key, label, selected })),
      )
      .then(function(result) {
        if (result) {
          vm.hideableColumns.forEach(col => {
            var item = result.find(x => x.key === col.key);
            if (!item) return;
            col.selected = !!item.selected;
          });
          vm.rebuildHiddenColumns();
          //Save hidden columns
          userStorage.setItem(
            columnSelectionStorageKey,
            vm.hideableColumns.filter(x => !x.selected).map(x => x.key),
          );
        }
      });
  };
  vm.initHiddenColumns();

  vm.canUpdate = reg => {
    if (reg.invoiceStatus > 1) return false;
    if (reg.userId === vm.currentUser.userID) return true;
    return canEditOthers;
  };
  vm.selectAllChanged = function() {
    if (!vm.table || !vm.table.rows) return;
    angular.forEach(vm.table.rows, function(el) {
      el.selected = vm.selectAll;
    });
  };

  vm.selectedCount = function() {
    if (!vm.table || !vm.table.rows) return 0;
    const total = vm.totalRowCount || 0;
    const count = vm.table.rows.reduce(
      (cnt, reg) => cnt + (!!reg.selected !== vm.selectAll ? 1 : 0),
      0,
    );
    return vm.selectAll ? total - count : count;
  };
  vm.getBatchSelectionParams = function() {
    return {
      selectAll: vm.selectAll,
      ids:
        vm.table && vm.table.rows
          ? vm.table.rows.filter(reg => !!reg.selected !== vm.selectAll).map(reg => reg.id)
          : [],
    };
  };
  vm.batchUpdateField = function() {
    const sessionParams = JSON.parse(sessionStorage.getItem('RegistrationOverviewParams'));
    if (!sessionParams) return;

    const tableParams = sessionParams.tableParams;
    if (!tableParams) return;
    var batchParams = vm.getBatchSelectionParams();
    var filters = vm.getFilters();
    vm.globalActionRunning = true;

    regDialogsSvc
      .batchUpdateField({ ...filters, ...tableParams }, batchParams)
      .then(result => {
        if (!result || !result.count) return;
        if (!vm.table || !vm.table.rows) return;
        const boolValue = !!result.boolValue;

        vm.table.rows.forEach(reg => {
          if (!vm.canUpdate(reg)) return;
          if (!reg.selected) return;
          switch (parseInt(result.field)) {
            case 1:
              reg.neverInvoice = boolValue;
              return;
            case 2:
              reg.isBillable = boolValue;
              return;
            case 3:
              if (reg.inForfait === null) return;
              reg.inForfait = boolValue;
              return;
          }
        });
      }, showError)
      .finally(() => {
        vm.globalActionRunning = false;
      });
  };
  vm.batchBillRegistrations = function() {
    const sessionParams = JSON.parse(sessionStorage.getItem('RegistrationOverviewParams'));
    if (!sessionParams) return;

    const tableParams = sessionParams.tableParams;
    if (!tableParams) return;
    dialogsSvc.showYesNo('comfirmTitle', 'msgConfirmBillRegistrations').then(function() {
      vm.globalActionRunning = true;
      var batchParams = vm.getBatchSelectionParams();
      var filters = vm.getFilters();
      vm.table.rows
        .filter(
          reg => vm.canUpdate(reg) && !!reg.selected !== vm.selectAll && reg.invoiceStatus == 0,
        )
        .forEach(reg => {
          reg.addingToDraft = true;
        });
      vm.manipulatingDrafts = true;
      $http
        .post(`${appUrls.api}/api/Registration/BatchBill`, batchParams, {
          params: { ...filters, ...tableParams },
        })
        .then(
          function({ data }) {
            if (data && data.id) {
              flySvc.action('msgJobStarted', undefined, 'jobs.detail', undefined, {
                jobId: data.id,
              });
            }

            vm.globalActionRunning = false;
          },
          function(error) {
            showError(error);
            vm.globalActionRunning = false;
            vm.manipulatingDrafts = false;
          },
        );
    });
  };

  vm.batchUnbillRegistrations = function() {
    const sessionParams = JSON.parse(sessionStorage.getItem('RegistrationOverviewParams'));
    if (!sessionParams) return;

    const tableParams = sessionParams.tableParams;
    if (!tableParams) return;
    invoiceDialogsSvc
      .deleteWithNeverInvoice('comfirmUndoOrNeverInvoiceRegistrations')
      .then(function(neverInvoice) {
        vm.globalActionRunning = true;

        var batchParams = vm.getBatchSelectionParams();
        var filters = vm.getFilters();
        vm.table.rows
          .filter(
            reg => vm.canUpdate(reg) && !!reg.selected !== vm.selectAll && reg.invoiceStatus == 1,
          )
          .forEach(reg => {
            reg.removingFromDraft = true;
          });
        vm.manipulatingDrafts = true;
        $http
          .post(`${appUrls.api}/api/Registration/BatchUnbill`, batchParams, {
            params: { ...filters, ...tableParams, neverInvoice },
          })
          .then(
            function({ data }) {
              if (data && data.id) {
                flySvc.action('msgJobStarted', undefined, 'jobs.detail', undefined, {
                  jobId: data.id,
                });
              }

              vm.globalActionRunning = false;
            },
            function(error) {
              showError(error);
              vm.globalActionRunning = false;
              vm.manipulatingDrafts = false;
            },
          );
      });
  };

  function jobUpdateHandler(job) {
    if (
      (job.jobType === 38 ||
        job.jobType === 62 ||
        job.jobType === 66 ||
        job.jobType === 67 ||
        job.jobType === 68) &&
      (job.status === 2 || job.status === 3)
    ) {
      //Batch bill registrations finished
      $timeout(function() {
        vm.manipulatingDrafts = false;
        vm.reloadRegistrations();
      }, 100);
    }
  }
  SignalRService.subscribe('jobUpdated', jobUpdateHandler);

  $scope.$on('$destroy', function() {
    if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
      vm.retrieveRequest.$cancelRequest();
    if (vm.kpiRequest && vm.kpiRequest.$cancelRequest) vm.kpiRequest.$cancelRequest();
    SignalRService.unsubscribe('jobUpdated', jobUpdateHandler);
  });

  vm.openTaskDetail = function(registration) {
    vm.taskDetail = { id: registration.plannedTaskId };
  };

  vm.closeTaskDetail = function() {
    $timeout(() => {
      vm.taskDetail = null;
    }, 0);
  };

  if (!vm.filtersInitialised) {
    setParamsFromSessionStorage();
  }

  vm.canEditTask = function(registration) {
    if (!registration) return false;

    const hasTodoPermission = AuthService.hasPermission({
      functionality: 'Todo',
      privilege: 'Update',
    });
    const hasPlannedTaskPermission = AuthService.hasPermission({
      functionality: 'PlannedTask',
      privilege: 'Update',
    });

    return hasTodoPermission && hasPlannedTaskPermission;
  };
}
